import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

// GET ALL
export const fetchRoles = createAsyncThunk(
  "role/fetchRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(API_ENDPOINTS.GET_ROLES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// CREATE
export const createRole = createAsyncThunk(
  "role/createRole",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.post(
        API_ENDPOINTS.CREATE_ROLE,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// UPDATE
export const updateRole = createAsyncThunk(
  "role/updateRole",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.put(
        API_ENDPOINTS.UPDATE_ROLE,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// DELETE
export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.delete(
        `${API_ENDPOINTS.DELETE_ROLE}?userId=${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// SEARCH
export const searchRole = createAsyncThunk(
  "role/searchRole",
  async (name, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.SEARCH_ROLE}?roleName=${name}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const RoleSlice = createSlice({
  name: "role",
  initialState: {
    fetch: { data: [], loading: false, error: null },
    create: { data: null, loading: false, error: null },
    update: { data: null, loading: false, error: null },
    delete: { data: null, loading: false, error: null },
    search: { data: [], loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchRoles.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
      })

      // CREATE
      .addCase(createRole.pending, (state) => {
        state.create.loading = true;
        state.create.error = null;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.create.loading = false;
        state.create.data = action.payload;
      })
      .addCase(createRole.rejected, (state, action) => {
        state.create.loading = false;
        state.create.error = action.payload;
      })

      // UPDATE
      .addCase(updateRole.pending, (state) => {
        state.update.loading = true;
        state.update.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.update.loading = false;
        state.update.data = action.payload;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.update.loading = false;
        state.update.error = action.payload;
      })

      // DELETE
      .addCase(deleteRole.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.delete.loading = false;
        state.delete.data = action.payload;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
      })

      // SEARCH
      .addCase(searchRole.pending, (state) => {
        state.search.loading = true;
        state.search.error = null;
      })
      .addCase(searchRole.fulfilled, (state, action) => {
        state.search.loading = false;
        state.search.data = action.payload || [];
      })
      .addCase(searchRole.rejected, (state, action) => {
        state.search.loading = false;
        state.search.error = action.payload;
      });
  },
});

export default RoleSlice.reducer;
